import { Alert, Box, FormControlLabel, Switch } from '@mui/material';
import React from 'react';
import { StyledTypography } from '../../../components/styles/styles';
import { formatTimeLeft, useSupportLogging } from '../../../components/admin/useSupportLogging';

const SupportTab: React.FC = () => {
  const { active, secondsLeft, busy, error, setEnabled } = useSupportLogging();

  return (
    <Box>
      <StyledTypography sx={{ mb: 2 }}>
        Having a problem in the admin portal? Turn on log capture, then repeat what went wrong. Logs
        from this browser are sent to support so they can see what happened. It turns itself off
        after 30 minutes.
      </StyledTypography>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      <FormControlLabel
        control={
          <Switch
            checked={active}
            disabled={busy}
            onChange={(event) => void setEnabled(event.target.checked)}
          />
        }
        label="Capture my logs"
      />

      {active && (
        <StyledTypography variant="body2" color="text.secondary" data-testid="support-logging-left">
          Logging is on. It turns off by itself in {formatTimeLeft(secondsLeft)}.
        </StyledTypography>
      )}
    </Box>
  );
};

export default SupportTab;
